import { t } from "../../../services/utils";
import TitleView from "../components/TitleView";
import storyTypes from "../../../constants/storyTypes";
import Toolbar from "../components/Toolbar";
import Divider from "../components/Divider";
import LikesView from "../components/LikesView";
import CommentView from "../components/CommentView";
class BaseStoryViewModel {
  constructor(story, me, viewType, isModal) {
    this.story = story;
    this.me = me;
    this.viewType = viewType;
    this.isModal = isModal;
  }
  addContentViewModel = (parts, handler) => {
    throw new TypeError("Must override method");
  };
  addTitleViewModel = (parts, handler) => {
    parts.push({
      type: TitleView,
      props: {
        firstName: this.story.first_name,
        storyType: this.story.story_type,
        date: this.getStoryDate(),
        photoId: this.story.photo_id,
        isPublic: this.story.is_public,
        pinned: this.story.pinned,
        storyId: this.story.story_id,
        clientId: this.story.user_id,
        primaryTrainer: this.story.primary_trainer,
        viewType: this.viewType,
        handler: handler,
        goal:
          this.story.story_type === storyTypes.ASSESSMENT &&
          this.story.story.go,
      },
      key: `ti-${this.story.story_id}`,
    });
  };
  addToolbarViewModels = (parts, handler) => {
    let likedByMe = false;
    let likes = this.story.likes;
    const { comments } = this.story;
    for (let i = 0; i < likes.length; i++) {
      if (likes[i].user_id === this.me.id) {
        likedByMe = true;
        break;
      }
    }
    parts.push({
      type: Toolbar,
      props: {
        handler: handler,
        storyId: this.story.story_id,
        likedByMe: likedByMe,
        likes: likes,
        comments: comments,
        me: this.me,
      },
      // key: BaseStoryViewModel.getAddCommentViewKey(this.story.story_id)
    });
  };

  addDivider = (parts, prefix) => {
    parts.push({
      type: Divider,
      props: {},
      key: `${prefix}-di-${this.story.story_id}`,
    });
  };
  addLikesViewModel = (parts) => {
    parts.push({
      type: LikesView,
      props: {
        likes: this.story.likes,
      },
      key: `likes-${this.story.story_id}`,
    });
  };
  addCommentViewModel = (parts, handler, commentIndex, paddingTop) => {
    let part = {
      type: CommentView,
      // props: { ...this.story.comments[commentIndex] },
      props: {
        comments: this.story.comments,
        handler: handler,
        storyId: this.story.story_id,
        expanded: BaseStoryViewModel.getCommentsExpanded(this.story.story_id),
        me: this.me,
      },
      key: BaseStoryViewModel.getAddCommentViewKey(this.story.story_id),
    };
    if (paddingTop) {
      part.props.paddingTop = paddingTop;
    }
    parts.push(part);
  };
  getStoryDate = () => {
    throw new TypeError("Must override method");
  };
  getStoryId = () => {
    return this.story.story_id;
  };
  static canUnderstand(story) {
    let supportedTypes = Object.values(storyTypes);
    return supportedTypes.includes(story.story_type);
  }
  static getAddCommentViewKey = (storyId) => {
    return `ac-${storyId}`;
  };
  static setCommentsExpanded = (storyId, value) => {
    BaseStoryViewModel.expanded[`ac-${storyId}`] = value;
  };
  static getCommentsExpanded = (storyId) => {
    return BaseStoryViewModel.expanded;
  };
  static expanded = {};
  getPartsViewModel = (handler) => {
    let parts = [];
    this.addTitleViewModel(parts, handler);
    this.addContentViewModel(parts, handler);
    this.addToolbarViewModels(parts, handler);
    this.addCommentViewModel(parts, handler);
    return parts;
  };
}
export default BaseStoryViewModel;
